/**
 * @description Device Smart Tag is embedded by
 */
export enum EmbedDevice {
	DESKTOP = 'DESKTOP',
	ANDROID_PHONE = 'Android Phone',
	ANDROID_TV = 'androidtv',
	IPHONE = 'iPhone',
	IPAD = 'iPad',
	KINDLE = 'Kindle',
	/** Unspecified Tablet */
	TABLET = 'Tablet',
	MOBILE = 'Mobile',
	/** Unspecified Embedded */
	EMBEDDED = 'Embedded',
	/** > Only Web0S 3.5 and above is supported */
	LG_WEB_OS = 'lg-webos',
	/** LG NetCast */
	LG_NETCAST = 'lg-netcast',
	/** Only Vizio Smartcast Devices */
	VIZIO_SMART_TV = 'vizio',
	/** Samsung Tizen Devices */
	SAMSUNG_SMART_TV = 'samsung-orsay',
	SAMSUNG_TIZEN = 'samsung-tizen',
	SAMSUNG = 'samsung',
	/** Comcast X1 Devices */
	COMCAST = 'comcast',
	/** Xbox One X one S Devices */
	XBOX_ONE = 'xboxone',
	CHROMECAST = 'Chromecast',
	PS4 = 'ps4',
	PS5 = 'ps5',
	TCL = 'tcl',
	COX = 'cox',
	/** SONY_HTML5 */
	SONY_HTML5 = 'sony',
	NETGEM = 'netgem',
	SAGEM = 'sagem',
	VIDAA = 'vidaa',
	TIVO = 'tivo',
	FIRETV = 'firetv',
	/** Unspecified or unknown */
	UNKNOWN = 'unknown'
}